import { useState } from "react";
import "../ReportTable.css";
import { useCallback } from "react";
import { Table } from "react-bootstrap";
import CustomerFooter from "./CustomerFooter";
import HeaderCustomer from "./HeaderCustomer";
import './Customer.css';
import ApiHandler from "../../ApiHandler";
import TransferData from "../../TransferData";
import LoaderTri from "../Loader/LoaderTri";
import FirmSelect from './FirmSelect';
import { getReportFirmId, getReportFirmLocalUrl, getReportFirmName } from '../../ClientSelection';
import dayjs from "dayjs";
import { dateField } from "../../dateOnly";
import ReportExport from "../ReportExport";
import { getLoginId } from "../../loginUser";

export default function PendingBills() {


    const [showPendingBillData, setShowPendingBillData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);



    // This screen has no View button - it loads on mount and again whenever the
    // firm changes, so the pending bills always belong to the firm on show.
    // GetPendingBill lives on the FIRM'S OWN server, so the firm is passed in
    // rather than read from a cached LocalURL: both its url and its client id
    // come from the dropdown.
    const loadPendingBills = useCallback((firm) => {

        const localUrl = (firm && firm.localUrl) || getReportFirmLocalUrl();
        const clientId = (firm && firm.wClientId) || getReportFirmId();

        if (!localUrl) {
            console.error('No local server for the selected firm');
            setShowPendingBillData([])
            return;
        }

        if (!clientId) {
            console.error('No firm selected');
            setShowPendingBillData([])
            return;
        }

        setIsLoading(true)
        setShowPendingBillData([])
        // `code` is the id the customer signs in with - see loginUser.js for
        // why that is not `user-info.userId`.
        const loginId = getLoginId()
        const today = dayjs().format("YYYYMMDD")
        ApiHandler.post({
            url: localUrl + "api/OwnApp/GetPendingBill",
            data: {
                startdate: today,
                enddate: today,
                code: loginId,
                // the firm from the dropdown, as its own field
                wClientId: clientId,

            }, useUserUrl: true
        })
            .then(((result) => {
                setShowPendingBillData(result.data)

            }))
            .catch(err => {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }
            })
            .finally(() => {
                setIsLoading(false)
            })





        // axios.post(localUrl + "api/OwnApp/GetPendingBill", {
        //     startdate: "20210101",
        //     enddate: "20230712",
        //     code: 15201,
        // },

        // )
        //     .then(((result) => {
        //         console.log(result);
        //         console.log(result.data);
        //         setShowPendingBillData(result.data)


        //     }))
        //     .catch(err => {
        //         console.error(err);
        //         if (err.response && err.response.status && err.response.status === 401) {
        //             console.log(err.response);
        //             //   RefreshTokenHandler();
        //             //  ToastError("Token has expired Please refresh");
        //         }
        //     }

        //     )
    }, []);

    // The first load is driven by FirmSelect's onReady, not by mount: the firm
    // list arrives after mount, so fetching here would use a stale firm or,
    // on a first visit, no firm at all.

    // Reload for the firm just picked. FirmSelect hands the firm object over,
    // so its localUrl and client id are used directly rather than relying on
    // the stored value having been written first.
    const handleFirmChange = (firm) => {
        loadPendingBills(firm);
    };







    const exportColumns = [
        { key: "billDate", label: TransferData.billDate, format: (v, row) => dateField(row, "billDate", "date") },
        { key: "billNo", label: TransferData.billNo },
        { key: "amount", label: TransferData.amount, align: "right" },
        { key: "pending", label: TransferData.pending, align: "right" },
        { key: "duedate", label: TransferData.duedate, format: (v, row) => dateField(row, "duedate", "dueDate") },
        { key: "runningTotal", label: TransferData.runningTotal, align: "right" },
        { key: "days", label: TransferData.days, align: "right" },
    ];

    return (
        <div className="custShell">
            <HeaderCustomer />

            <div className="custMain">

                <div className="d-flex justify-content-center"  >
                    <div className="pendingBillData"  >

                        <div className="row m-0">
                            <div className="col-lg-6 offset-lg-3   ">
                                <div className="pendingBill row">
                                    <div className="col-6 col-lg-6 ">
                                        <h4>Pending Bills</h4>
                                    </div>

                                </div>

                                <div className="row mb-2 align-items-center">
                                    <div className="col-lg-6">
                                        <FirmSelect
                                            onReady={handleFirmChange}
                                            onChange={handleFirmChange}
                                        />
                                    </div>

                                    {/* the downloads sit on the firm's line,
                                        right-aligned */}
                                    <div className="col-lg-6">
                                        <ReportExport
                                            className="rptExportEnd"
                                            title="Pending Bills"
                                            subtitle={[
                                                getReportFirmName(),
                                                "As on " + dayjs().format("DD-MM-YYYY"),
                                            ]}
                                            columns={exportColumns}
                                            rows={showPendingBillData}
                                            fileName="pending-bills"
                                        />
                                    </div>
                                </div>



                                <div className="rptScroll">
                                    <Table striped className="rptTable">
                                        <thead className="threAd" >
                                            <tr className="threAd_tr">

                                                <th>{TransferData.billDate}</th>
                                                <th>{TransferData.billNo}</th>
                                                {/* figures right-aligned, so they line up down the column */}
                                                <th className="rptAmt">{TransferData.amount}</th>
                                                <th className="rptAmt">{TransferData.pending}</th>
                                                <th>{TransferData.duedate}</th>
                                                <th className="rptAmt">{TransferData.runningTotal}</th>
                                                <th className="rptAmt">{TransferData.days}</th>


                                            </tr>
                                        </thead>

                                        {




                                            showPendingBillData.map((elm, index) => {
                                                return <tbody className="tboDY" key={index} >
                                                    <tr className={elm._Color === "Y" ? "rptRowFlag" : undefined}>
                                                        <td>{dateField(elm, 'billDate', 'date')}</td>
                                                        <td>{elm.billNo}</td>
                                                        <td className="rptAmt">{elm.amount}</td>
                                                        <td className="rptAmt">{elm.pending}</td>
                                                        <td>{dateField(elm, 'duedate', 'dueDate')}</td>
                                                        <td className="rptAmt">{elm.runningTotal}</td>
                                                        <td className="rptAmt">{elm.days}</td>

                                                    </tr>


                                                </tbody>
                                            })
                                        }
                                    </Table >
                                </div>

                            </div>
                        </div>

                        {isLoading &&
                            <div className="d-flex justify-content-center" >

                                <LoaderTri />

                            </div>

                        }
                    </div>
                </div>



            </div >
            <CustomerFooter />
        </div>
    )
}